<template lang="pug">
  .find-job
    .search-wrap
      .section
        .container
          h1 {{ gettext('All jobs') }}
          .search
            .field.is-grouped
              .control.is-expanded
                input.input.has-addons-left(
                  type="text"
                  :placeholder="gettext('Enter the profession, for example, tractor driver')"
                  v-model="filters.query"
                  @keyup.enter="search()"
                )
                button.button.search-button(@click="search()")
                  i.mdi.mdi-magnify.icon-search
    .content-wrap
      .section
        .container
          .level.is-mobile.level-top
            .level-left
              p {{ gettext('Choose your search criteria') }}
            .level-right
              div
                .dropdown(:class="{'is-active': orderTrigger}" v-on-away="away")
                  .dropdown-trigger
                    button.button(@click="orderTrigger = !orderTrigger")
                      span {{ gettext(order) | upper}}
                  .dropdown-menu(role="menu")
                    .dropdown-content
                      a.dropdown-item(@click="changeOrder('updated')") {{ gettext('updated') | upper }}
                      a.dropdown-item(@click="changeOrder('salary')") {{ gettext('salary') | upper }}
          .tile.is-ancestor
            .tile.is-parent.is-vertical.types-block
              .accordions-wrap
                .accordions.accordions-mobile(:class="{'active': mobileFiltersAccordion}")
                  .accordions-mobile-head(@click="mobileFiltersAccordion = !mobileFiltersAccordion") {{gettext('Filters')}}
                  .accordions-mobile-body
                    v-popover(:placement="'left-center'" :trigger="'manual'" :open="popover.countries" :autoHide="false")
                      accordion(
                      :title="gettext('Country')"
                      @opened="receive({method: 'receiveCountries', params: {lang: getLanguage, filters: ['for_employer_profile']}, attr: 'countries'})"
                      @closed="closePopover()"
                      )
                        searchable-select(
                        :option="gettext('Does not matter')"
                        v-model="filters.country"
                        :items="received.countries"
                        :searchable="true"
                        :multiple="false"
                        :hideSelected="true"
                        :closeOnSelect="true"
                        @input="showPopover('countries')"
                        )
                      template(slot="popover")
                        button.main-btn.col-white.bg-red.popover-btn(@click="search()") {{ gettext('Search') }}

                    v-popover(:placement="'left-center'" :trigger="'manual'" :open="popover.company_type" :autoHide="false")
                      accordion(
                      :title="gettext('Choose industry')"
                      @opened="receive({method: 'receiveCompanyTypes', params: {lang: getLanguage, country: null}, attr: 'company_type'})"
                      @closed="closePopover()"
                      )
                        ajax-radio(
                        v-if="received.company_type.length"
                        :option="gettext('Does not matter')"
                        v-model="filters.company_type"
                        :items="received.company_type"
                        @input="filters.company_type.id ? receive({method: 'receiveCompanySectors', params: {lang: getLanguage, type: filters.company_type.id}, attr: 'company_sectors'}) : false; showPopover('company_type')"
                        )
                      template(slot="popover")
                        button.main-btn.col-white.bg-red.popover-btn(@click="search()") {{ gettext('Search') }}

                    v-popover(:placement="'left-center'" :trigger="'manual'" :open="popover.employment_types" :autoHide="false")
                      accordion(
                      :title="gettext('Employment type')"
                      @opened="receive({method: 'receiveEmploymentTypes', params: {lang: getLanguage}, attr: 'employment_types'}), openPopover('employment_types')"
                      @closed="closePopover()"
                      :loadOpened="Number.isInteger(parseInt($route.query.emt))"
                      )
                        ajax-checkbox(
                        v-if="received.employment_types.length"
                        v-model="filters.employment_types"
                        :items="received.employment_types"
                        @input="showPopover('employment_types')"
                        )
                      template(slot="popover")
                        button.main-btn.col-white.bg-red.popover-btn(@click="search()") {{ gettext('Search') }}

              button.main-btn.col-white.bg-red(@click="search()") {{ gettext('Search') }}
              button.main-btn.col-white.bg-gray.filter-btn(@click="clearFilters") {{ gettext('Clear filters') }}

            .tile.is-parent.is-9.main-block
              .content.is-fluid(v-if="!(offers.items || {}).length && offers.items")
                .notification
                  .has-text-centered.is-size-4 {{ gettext('Sorry, but there are no results for your search') }}
              .content.vacancy-wrap(v-else)
                vacancy-preview(v-for="(offer, index) in offers.items" :offer="offer" :allCategories="allCategories" :key="index")
                .vacancy.wide(v-if="!CONSTANTS.HIDE_INACTIVE")
                  router-link.img-wrap(:to="`/${getLanguage}/`")
                    img.img-get(src="@/assets/images/worker-get-job.png")
                    .btn-get.show {{ gettext('Get job abroad!') }}

          .tile.is-ancestor
            .tile.is-parent.is-hidden-mobile
            .tile.is-parent.is-9.main-block
              vue-paginate(
                v-if="offers.total_items"
                :page-count="offers.total_pages"
                :page-range="3"
                :initial-page="currentPage-1"
                :clickHandler="toPage"
              )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import AjaxDropdown from '@/components/ajax-dropdown'
import AjaxMultiselect from '@/components/ajax-multiselect'
import AjaxCheckbox from '@/components/ajax-checkbox'
import AjaxRadio from '@/components/ajax-radio'
import Accordion from '@/components/accordion'
import VuePaginate from '@/components/paginate'
import VacancyPreview from './parts/vacancy-preview'
import {VPopover, VClosePopover} from 'v-tooltip'
import { directive as onAway } from 'vue-clickaway'
import SearchableSelect from './../components/searchable-select'
import mixin from '@/mixins'

const CONSTANTS = require('@/constants.json')
const _ = require('lodash')

export default {
  name: 'Offers',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    AjaxDropdown,
    AjaxMultiselect,
    AjaxCheckbox,
    AjaxRadio,
    Accordion,
    VuePaginate,
    VacancyPreview,
    VPopover,
    VClosePopover,
    SearchableSelect
  },
  directives: {
    onAway
  },
  data () {
    return {
      seasonalReady: false,
      CONSTANTS: CONSTANTS,
      sectorState: false,
      orderTrigger: false,
      order: 'updated',
      timeout: null,
      mobileFiltersAccordion: false,
      currentPage: parseInt(this.$route.query.page) || 1,
      offers: {},
      aliases: {
        country: 'c',
        company_type: 'ct',
        company_sectors: 'cs',
        height: 'h',
        accommodation: 'ac',
        employment_types: 'emt',
        experience_time: 'et',
        driving_licences: 'dl',
        languages: 'l',
        query: 'q',
        page: 'page',
        order: 'order',
        seasonal: 'seasonal'
      },
      filters: {
        query: '',
        category: {},
        country: {},
        employment_types: [],
        accommodation: null,
        company_type: {},
        height: [],
        experience_time: [],
        driving_licences: [],
        languages: [],
        company_sectors: []
      },
      received: {
        countries: [],
        company_type: [],
        employment_types: [],
        company_sectors: [],
        height: [],
        experience_time: [],
        driving_licences: [],
        languages: [],
        additional_languages: [],
        speaking_lang_levels: []
      },
      allCategories: [],
      popover: {},
      activeGrid: false,
      filterUpdated: false,
      receiveInfo: {}
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'searchVacancy',
      'receiveEmploymentTypes',
      'receiveCompanyTypes',
      'receiveCompanySectors',
      'receiveBodyHeightRangeFilterItems',
      'receiveExperienceTimeRangeFilterItems',
      'receiveDrivingLicences',
      'receiveSpeakingLanguages',
      'receiveCountries'
    ]),
    getAllCategories () {
      this.receiveCompanyTypes({lang: this.getLanguage, country: null}).then(res => {
        this.allCategories = _.sortBy(res, ['id'])
      })
    },
    search (page, filters) {
      this.closeAllFilters()
      if (this.filterUpdated) page = 1
      if (page) this.currentPage = page
      this.setQuery(filters || this.getFilters())
      this.searchVacancy({
        lang: this.getLanguage,
        q: this.filters.query,
        page: page || this.currentPage,
        size: CONSTANTS.SEARCH_JOB_PAGE_SIZE || this.$store.state.pageSize,
        order: this.order,
        filters: this.formatter(filters) || this.formatter(this.getFilters())
      }).then(res => {
        this.offers = res
        this.filterUpdated = false
      })
    },
    receive ({method, params, attr}) {
      return new Promise(resolve => {
        this[method](params).then(res => {
          this.received[attr] = res
          this.setReceiveInfo(method, params, attr, res)
          resolve(res)
        })
      })
    },
    setReceiveInfo (method, params, attr, res) {
      this.$set(this.receiveInfo, attr, {
        params,
        handler: this[method],
        len: res.length
      })
    },
    languageReload () {
      _.each(this.receiveInfo, async (item, key) => {
        if (item.len) {
          let params = _.isString(item.params) ? this.getLanguage : {...item.params, ...{lang: this.getLanguage}}
          this.received[key] = await item.handler(params)
        }
      })
    },
    getAlias (alias) {
      let result
      _.each(this.aliases, (item, key) => {
        if (item === alias) result = key
        else if (key === alias) result = item
      })
      return result || alias
    },
    loadDictonaries (filter) {
      return new Promise(resolve => {
        if (filter === 'l') this.receive({method: 'receiveSpeakingLanguages', params: {lang: this.getLanguage}, attr: 'languages'}).then(res => resolve(res))
        if (filter === 'h') this.receive({method: 'receiveBodyHeightRangeFilterItems', params: {lang: this.getLanguage, type: 'cv'}, attr: 'height'}).then(res => resolve(res))
        if (filter === 'a') this.receive({method: 'receiveAgeRangeFilterItems', params: {lang: this.getLanguage, type: 'cv'}, attr: 'age'}).then(res => resolve(res))
        if (filter === 'et') this.receive({method: 'receiveExperienceTimeRangeFilterItems', params: {lang: this.getLanguage, type: 'cv'}, attr: 'experience_time'}).then(res => resolve(res))
        if (filter === 'dl') this.receive({method: 'receiveDrivingLicences', params: {lang: this.getLanguage}, attr: 'driving_licences'}).then(res => resolve(res))
        if (filter === 'emt') this.receive({method: 'receiveEmploymentTypes', params: {lang: this.getLanguage}, attr: 'employment_types'}).then(res => resolve(res))
        if (filter === 'ct') this.receive({method: 'receiveCompanyTypes', params: {lang: this.getLanguage, country: null}, attr: 'company_type'}).then(res => resolve(res))
        if (filter === 'c') this.receive({method: 'receiveCountries', params: {lang: this.getLanguage, filters: ['for_employer_profile']}, attr: 'countries'}).then(res => resolve(res))
        if (['g', 'q', 'cs'].indexOf(filter) !== -1) resolve()
      })
    },
    changeSectorState () {
      if (!this.filters.category.id) {
        this.sectorState = true
        setTimeout(() => {
          this.sectorState = false
        }, 2000)
      }
    },
    openPopover (item) {
      if (!this.popover[item]) {
        this.popover = {}
        this.$set(this.popover, item, true)
      } else {
        this.popover = {}
      }
    },
    closePopover () {
      this.popover = {}
    },
    showPopover (item) {
      if (window.innerWidth < 768) {
        this.popover = {}
      } else {
        this.popover = {}
        this.$set(this.popover, item, true)
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.popover = {}
        }, 5000)
      }
    },
    getFilters () {
      return {
        country: this.filters.country.id || null,
        company_type: this.filters.company_type.id || null,
        company_sectors: _.map(this.filters.company_sectors, item => item.id),
        accommodation: this.filters.accommodation,
        height: this.filters.height.id || null,
        experience_time: this.filters.experience_time.id || null,
        driving_licences: _.map(this.filters.driving_licences, item => item.id),
        languages: _.map(this.filters.languages, item => item.id),
        employment_types: _.map(this.filters.employment_types, item => item.id),
        query: this.filters.query,
        page: this.currentPage,
        order: this.order
      }
    },
    setFilters (query) {
      if (!_.isEmpty(query)) {
        _.each(query, (item, key) => {
          if (item) {
            this.loadDictonaries(key).then(() => {
              this.filters[this.getAlias(key)] = item.toString()
            })
          }
        })
      }
    },
    getQuery: function () {
      let result = {}
      if (Object.keys(this.$route.query).length) {
        _.each(this.$route.query, (item, key) => {
          if (_.isArray(item)) {
            item = _.map(item, val => {
              if (_.isString(val)) {
                return val.split(',').length > 1 ? _.map(val.split(','), i => parseInt(i)) : parseInt(val)
              }
              return val
            })
          } else {
            if (key !== 'q' && key !== 'order') item = item.toString().split(',').length > 1 ? [_.map(item.split(','), i => parseInt(i))] : parseInt(item)
          }
          result[this.getAlias(key)] = item
        })
        _.each(result, async (i, k) => {
          if (['company_sectors', 'driving_licences', 'languages', 'employment_types'].indexOf(k) !== -1) {
            result[k] = [i]
            result[k] = _.flattenDepth(result[k], 1)
          }
          if (k === 'query') this.filters.query = i
          if (k === 'page') this.currentPage = i
          if (k === 'order') this.order = i
          if (k === 'seasonal') {
            await this.receive({method: 'receiveEmploymentTypes', params: {lang: this.getLanguage}, attr: 'employment_types'})
            this.seasonalReady = true
            this.filters.employment_types = _.find(this.received.employment_types, {is_seasonal: true})
          }
        })
        return _.omit(result, ['page', 'order', 'seasonal'])
      }
      return false
    },
    setQuery (filters) {
      filters = Object.assign(filters, {query: this.filters.query})
      let query = {}
      _.each(filters, (item, key) => {
        if (item) {
          if (_.isArray(item)) query[this.getAlias(key)] = _.map(item, i => i.id || i)
          else query[this.getAlias(key)] = item
        }
      })
      let page = filters.page || this.currentPage
      if (parseInt(page) > 1) query.page = page
      else query = _.omit(query, 'page')
      if (this.order === 'updated') query = _.omit(query, 'order')
      this.$router.replace({query: query})
      this.$forceUpdate()
    },
    clearFilters () {
      this.filters.country = -1
      this.filters.company_type = {}
      this.filters.company_sectors = -1
      this.filters.accommodation = null
      this.filters.height = {}
      this.filters.experience_time = {}
      this.filters.driving_licences = -1
      this.filters.languages = -1
      this.filters.employment_types = -1
      this.search()
    },
    toPage (page) {
      this.search(+page)
    },
    formatter (data) {
      let result = data
      _.each(data, (item, key) => {
        if (item === null || item === undefined || key === 'query' || key === 'page' || key === 'order') result = _.omit(result, key)
        if (_.isArray(item)) if (!item.length) result = _.omit(result, key)
      })
      return result
    },
    away () {
      this.orderTrigger = false
    },
    changeOrder (order) {
      this.order = order
      this.orderTrigger = false
      this.search()
    },
    closeAllFilters () {
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (w <= 768) this.$bus.$emit('accordion_close', true)
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Search job'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  },
  created () {
    this.getAllCategories()
    window.addEventListener('resize', () => {
      if (window.innerWidth < 768) {
        this.popover = {}
      }
    })
    if (Object.keys(this.$route.query).length) {
      this.setFilters(this.$route.query)
      this.search(this.currentPage, this.getQuery())
    } else {
      this.search(this.currentPage)
    }
  },
  watch: {
    getLanguage: function () {
      this.languageReload()
      this.search()
    },
    filters: {
      deep: true,
      handler () {
        this.filterUpdated = true
      }
    }
  },
  filters: {
    upper: function (val) {
      return val.charAt(0).toUpperCase() + val.substr(1)
    }
  }
}

</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/search/find-job/index.vue